import { Fragment, useEffect, useState } from "react";
import PageTitle from "../../layouts/PageTitle";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { fetchAllSubCategories } from "../../../services/subcategories";
import Subcategories from "../AppsMenu/Shop/Subcategory/Subgategories";
import DisplayOrientationBulkBar from "./DisplayOrientationBulkBar";
import axios from "axios";
import config from "../../../../config.json";
import "./kitchenLuxe.css";

const SubcategoriesGrid = () => {
  const { t } = useTranslation();
  const [subcategories, setSubcategories] = useState([]);
  const [filteredSubcategories, setFilteredSubcategories] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [error, setError] = useState("");
  const [isError, setIsError] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);
  const [bulkSaving, setBulkSaving] = useState(false);

  // Fetch des subcategories
  const fetchSubcategories = async () => {
    try {
      const data = await fetchAllSubCategories();
      setSubcategories(data);
      setFilteredSubcategories(data);
      setIsError(false);
    } catch (err) {
      console.error("Erreur fetch subcategories:", err);
      setError("Failed to fetch subcategories. Please try again later.");
      setIsError(true);
    }
  };

  useEffect(() => {
    fetchSubcategories();
  }, []);

  // Filtrage par titre
  useEffect(() => {
    const results = subcategories.filter((sub) =>
      sub.subCategoryDetails.some((detail) =>
        detail.title.toLowerCase().includes(searchTerm.toLowerCase())
      )
    );
    setFilteredSubcategories(results);
  }, [searchTerm, subcategories]);

  const visibleIds = filteredSubcategories
    .filter((sub) => !sub.isArchived)
    .map((sub) => sub._id);
  const selectedVisible = selectedIds.filter((id) => visibleIds.includes(id));
  const allSelected =
    visibleIds.length > 0 && selectedVisible.length === visibleIds.length;

  const toggleSelect = (id) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  const applyOrientation = async (orientation, all) => {
    setBulkSaving(true);
    try {
      await axios.put(
        `${config.dev}/v2/subcategories/display-orientation`,
        all
          ? { all: true, displayOrientation: orientation }
          : { ids: selectedVisible, displayOrientation: orientation },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("tokenLogin")}`,
          },
        }
      );
      setSelectedIds([]);
      await fetchSubcategories();
    } catch (err) {
      setError(err?.response?.data?.message || "Failed to update orientation.");
      setIsError(true);
    } finally {
      setBulkSaving(false);
    }
  };

  return (
    <Fragment>
      <div className="kitchen-page">
        <PageTitle activeMenu={t("subcategories")} motherMenu={t("menu")} />

        <div className="kitchen-toolbar">
          <div className="kitchen-toolbar__search">
            <input
              type="text"
              className="form-control"
              placeholder={t("searchByTitle")}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          <div className="kitchen-toolbar__actions">
            <Link to="/add-subcategory" className="kitchen-toolbar__add">
              <i className="fas fa-plus" />
              {t("addNewSubcategory")}
            </Link>
          </div>
          <DisplayOrientationBulkBar
            selectedCount={selectedVisible.length}
            totalCount={visibleIds.length}
            allSelected={allSelected}
            saving={bulkSaving}
            onToggleSelectAll={() =>
              setSelectedIds(allSelected ? [] : visibleIds)
            }
            onApplySelected={(orientation) => applyOrientation(orientation, false)}
            onApplyAll={(orientation) => applyOrientation(orientation, true)}
          />
        </div>

        <div className="row kitchen-grid">
          {isError || filteredSubcategories.length === 0 ? (
            <div className="col-12">
              <div className="kitchen-empty" role="alert">
                {isError ? error : t("noDataFound")}
              </div>
            </div>
          ) : (
            filteredSubcategories.map((sub) => (
              <Subcategories
                key={sub._id}
                subcategory={sub}
                fetchSubcategories={fetchSubcategories}
                selected={selectedIds.includes(sub._id)}
                onToggleSelect={toggleSelect}
              />
            ))
          )}
        </div>
      </div>
    </Fragment>
  );
};

export default SubcategoriesGrid;
